import "./index.scss";

import { Box, Stack } from "@mui/material";
import { ReactComponent as AddIcon } from "assets/images/icons/add.svg";
import { ReactComponent as TrashIcon } from "assets/images/icons/trash.svg";
import ScreenEmptySection from "components/ScreenEmptySection";
import React, { memo, useEffect, useState } from "react";
import { toast } from "react-toastify";

interface ManagedStringListProps {
  list: string[];
  callback: Function;
  limit?: number;
  length?: number;
}

const ManagedStringList = (props: ManagedStringListProps) => {
  const { list, callback, limit, length } = props;
  const [newEntry, setNewEntry] = useState<string>("");
  const [managedList, setManagedList] = useState<string[]>(list || []);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (callback) {
      callback(managedList);
    }
  }, [managedList]);

  const addEntry = () => {
    if (newEntry && (!limit || (limit && managedList.length < limit))) {
      setManagedList([...managedList, newEntry]);
    }
    if (limit && managedList.length === limit) {
      toast(`You can only add ${limit} entries.`, { type: "error" });
    }
    setNewEntry("");
  };

  const handleAddEntry = (e: React.MouseEvent) => {
    e.preventDefault();
    addEntry();
  };

  const handleEnter = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addEntry();
    }
  };

  const handleRemoveEntry = (index: number) => {
    let newList = [...managedList];
    newList.splice(index, 1);
    setManagedList(newList);
  };

  const [goalTextCount, setGoalTextCount] = useState<Record<number, number>>({});

  const handleUpdateEntry = (v: string, index: number) => {
    let newList = [...managedList];
    newList[index] = v;
    setManagedList(newList);

    const newCounts = { ...goalTextCount };
    newCounts[index] = v.length;
    setGoalTextCount(newCounts);
    console.log(`machineSettingsCount ${JSON.stringify(goalTextCount)}`);
  };

  return (
    <Box className={`searchable-list-container managed-string-list`}>
      <Stack direction={"row"} alignItems={"stretch"} className="header">
        {/* <Stack direction={"column"} alignItems={"stretch"}> */}
        <div className={`searchbar-container`}>
          <input
            type="text"
            value={newEntry}
            maxLength={length}
            onChange={(v) => {
              setNewEntry(v.target.value);
              setCount(v.target.value.length);
            }}
            onKeyDown={handleEnter}
          />
        </div>
        <Stack direction={"row"} alignItems={"right"} justifyContent={"flex-end"} gap={1}>
          {count}/{length}
        </Stack>
        {/* </Stack> */}
        <button onClick={(e) => handleAddEntry(e)} title="Add">
          <AddIcon />
        </button>
      </Stack>

      <Box className={`searchable-list-container managed-string-list`}>
        {managedList.map((entry, index) => (
          <Stack direction={"row"} alignItems={"stretch"} className="header">
            <div className={`searchbar-container`} key={`managedStringListEntry-${index}`}>
              <input
                type="text"
                value={entry}
                maxLength={length}
                onChange={(v) => handleUpdateEntry(v.target.value, index)}
              />
            </div>
            <Stack direction={"row"} alignItems={"right"} justifyContent={"flex-end"} gap={1}>
              {goalTextCount[index] == null ? 0 : goalTextCount[index]}/{length}
            </Stack>
            <button onClick={() => handleRemoveEntry(index)} title="Remove">
              <TrashIcon />
            </button>
          </Stack>
        ))}
        {!managedList.length && <ScreenEmptySection />}
      </Box>
    </Box>
  );
};

export default memo(ManagedStringList);
